import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { SetupRoutingModule } from './setup-routing.module';
import { SetupComponent } from './setup.component';
import { ContaService } from '../../shared/services/conta/conta.service';
import { DirectivesModule } from '../../shared/directives/directives.module';
import { FormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    SetupRoutingModule,
    HttpClientModule,
    DirectivesModule,
    FormsModule,
    NgxMaskModule.forRoot()
  ],
  declarations: [
    SetupComponent,
  ],
  providers: [
    ContaService
  ]
})
export class SetupModule { }



// WEBPACK FOOTER //
// ./src/app/modules/setup/setup.module.ts